// Version : 0.0.2
// Author : VISHAL BHARATHI
// LastEdit : VISHAL BHARATHI
// Last ADD : MODULE LIST RESPONSE ADDED
// MODFIED DATA : 05-08-2025

/* eslint-disable import/no-anonymous-default-export */
import questionnaireTypes from './questionaire.types';

import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	// ADD QUESTIONNAIRE RESPONSE
	addQuestionnaireResponse: null,
	// GET QUESTIONNAIRE LIST RESPONSE
	getQuestionnaireResponse: null,
	getQuestionnaireListArr: [],
	// DELETE QUESTIONNAIRE RESPONSE
	deleteQuestionnaireResponse: null,
	deleteQuestionResponse: null,
	// FETCH QUESTIONNAIRE RESPONSE
	fetchQuestionnaireArr: [],
	fetchQuestionnaireResponse: null,
	// UPDATE QUESTIONNAIRE RESPONSE
	updateQuestionnaireStatus: null,
	updateQuestionnaireResponse: null,
	// FETCH MODULE LIST RESPONSE
	fetchModuleListStatus: null,
	fetchModuleListResponse: null,
	fetchModuleListArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/****************** ADD QUESTIONNAIRE START ********************* */
		case questionnaireTypes.ADD_QUESTIONNAIRE_SUCCESS:
			return { ...state, addQuestionnaireResponse: action.payload };

		case questionnaireTypes.ADD_QUESTIONNAIRE_FAILURE:
			return { ...state, addQuestionnaireResponse: action.payload };

		case questionnaireTypes.ADD_QUESTIONNAIRE_RESPONSE_CHANGED:
			return { ...state, addQuestionnaireResponse: null };
		/****************** ADD QUESTIONNAIRE END ********************* */

		/****************** GET QUESTIONNAIRE LIST START ********************* */
		case questionnaireTypes.GET_QUESTIONNAIRE_SUCCESS:
			return {
				...state,
				getQuestionnaireResponse: action.payload,
				getQuestionnaireListArr: docodeHexResponse(
					action.payload,
					'GetAllQuestionnaireListkey',
				),
			};
		case questionnaireTypes.GET_QUESTIONNAIRE_FAILURE:
			return {
				...state,
				getQuestionnaireResponse: action.payload,
				getQuestionnaireListArr: [],
			};

		case questionnaireTypes.GET_QUESTIONNAIRE_RESPONSE_CHANGED:
			return { ...state, getQuestionnaireResponse: null };
		/****************** GET QUESTIONNAIRE LIST END ********************* */

		/****************** FETCH QUESTIONNAIRE START ********************* */
		case questionnaireTypes.FETCH_QUESTIONNAIRE_SUCCESS:
			return {
				...state,
				fetchQuestionnaireResponse: action.payload,
				fetchQuestionnaireArr: docodeHexResponse(
					action.payload,
					'FetchQuestionnaireListkey',
				),
			};

		case questionnaireTypes.FETCH_QUESTIONNAIRE_FAILURE:
			return {
				...state,
				fetchQuestionnaireResponse: action.payload,
				fetchQuestionnaireArr: [],
			};

		case questionnaireTypes.FETCH_QUESTIONNAIRE_RESPONSE_CHANGED:
			return { ...state, fetchQuestionnaireResponse: null };
		/****************** FETCH QUESTIONNAIRE END ********************* */

		/****************** DELETE QUESTIONNAIRE DETAILS START ********************* */
		case questionnaireTypes.DELETE_QUESTIONNAIRE_SUCCESS:
			return { ...state, deleteQuestionnaireResponse: action.payload };

		case questionnaireTypes.DELETE_QUESTIONNAIRE_FAILURE:
			return { ...state, deleteQuestionnaireResponse: action.payload };

		case questionnaireTypes.DELETE_QUESTIONNAIRE_RESPONSE_CHANGED:
			return { ...state, deleteQuestionnaireResponse: null };
		/****************** DELETE QUESTIONNAIRE DETAILS END ********************* */

		/****************** DELETE QUESTION DETAILS START ********************* */
		case questionnaireTypes.DELETE_QUESTION_SUCCESS:
			return { ...state, deleteQuestionResponse: action.payload };

		case questionnaireTypes.DELETE_QUESTION_FAILURE:
			return { ...state, deleteQuestionResponse: action.payload };

		case questionnaireTypes.DELETE_QUESTION_RESPONSE_CHANGED:
			return { ...state, deleteQuestionResponse: null };
		/****************** DELETE QUESTION DETAILS END ********************* */

		/****************** UPDATE QUESTIONNAIRE START ********************* */
		case questionnaireTypes.UPDATE_QUESTIONNAIRE_SUCCESS:
			return {
				...state,
				updateQuestionnaireStatus: 'Success',
				updateQuestionnaireResponse: action.payload,
			};

		case questionnaireTypes.UPDATE_QUESTIONNAIRE_FAILURE:
			return { ...state, updateQuestionnaireStatus: 'Failure' };

		case questionnaireTypes.UPDATE_QUESTIONNAIRE_RESPONSE_CHANGED:
			return { ...state, updateQuestionnaireStatus: null, updateQuestionnaireResponse: null };
		/****************** UPDATE QUESTIONNAIRE END ********************* */

		/****************** FETCH MODULE LIST START ********************* */
		case questionnaireTypes.FETCH_MODULE_LIST_SUCCESS:
			return {
				...state,
				fetchModuleListResponse: action.payload,
				fetchModuleListStatus: 'Success',
				fetchModuleListArr: docodeHexResponse(action.payload, 'ModuleListFetchKey'),
			};

		case questionnaireTypes.FETCH_MODULE_LIST_FAILURE:
			return {
				...state,
				fetchModuleListResponse: action.payload,
				fetchModuleListStatus: 'Failure',
			};

		case questionnaireTypes.FETCH_MODULE_LIST_CHANGED:
			return { ...state, fetchModuleListResponse: null, fetchModuleListStatus: null };
		/****************** FETCH MODULE LIST END ********************* */

		default:
			return state;
	}
};
